import { IconChecklist, IconFileText } from '@tabler/icons-react';
import { Link } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { UserRoleAccess } from '@/types';
import { UserRole } from '@/types';

interface SettingsLandingPageProps {
  checkpointsPath: string;
}

const SettingsLandingPage = ({
  checkpointsPath,
}: SettingsLandingPageProps) => {
  const queryClient = useQueryClient();
  const isNewsletterAvailable =
    queryClient.getQueryData<boolean>(['newsletter', 'availability']) ===
    true;
  const userRoleAccess = queryClient.getQueryData<
    AxiosResponse<UserRoleAccess>
  >(['userRoleAccess']);
  const canManageNewsletter =
    userRoleAccess?.data?.user?.roles?.includes(UserRole.RELEASE_NOTES_MANAGER) ===
    true;

  return (
    <div className="flex flex-col gap-4 px-4 lg:pr-8 py-4 h-full max-sm:h-auto max-sm:gap-3 max-sm:px-0 max-sm:py-0">
      <h1 className="text-2xl font-bold">Settings</h1>
      <div className="flex-1 w-full max-sm:flex-none">
        <div className="flex flex-wrap gap-4 max-sm:flex-col max-sm:gap-3">
          <Link
            to={checkpointsPath}
            className="flex border p-4 gap-2 max-sm:w-full"
          >
            <IconChecklist size={24} className="mt-0.5" />
            <div className="flex min-w-0 flex-col gap-1">
              <h2 className="text-lg font-bold">Checkpoints</h2>
              <p className="text-sm text-gray-500">
                Manage your checkpoints here.
              </p>
            </div>
          </Link>
          {isNewsletterAvailable && canManageNewsletter ? (
            <Link
              to="/newsletter/admin"
              className="flex border p-4 gap-2 max-sm:w-full"
            >
              <IconFileText size={24} className="mt-0.5" />
              <div className="flex min-w-0 flex-col gap-1">
                <h2 className="text-lg font-bold">Newsletter</h2>
                <p className="text-sm text-gray-500">
                  Create and publish newsletters.
                </p>
              </div>
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default SettingsLandingPage;
